<script>
    import Modal from './Modal.svelte';
	import { modal } from './stores.js';
    import PopupContent from './PopupContent.svelte';
</script>

<Modal show={$modal}>
    <PopupContent />
</Modal>